// CP-785 — the fixed set of "Visible To" portals shown in the admin Portal Manuals table.
// Portals are environment configuration, NOT admin-managed data: each deployed environment is
// configured (REACT_APP_MANUAL_PORTAL) with the portal it represents, and the end-user
// "Download Manual" button serves that portal's manual.
// Brand visibility is strict (CP-785): each brand's build shows only its own portals.
const ALL_PORTALS = [
  { key: 'CENTERLINE_CLIENT', label: 'Centerline Client Portal' },
  { key: 'CENTERLINE_SERVICE', label: 'Centerline Service Portal' },
  { key: 'PRST_SERVICE', label: 'PRST Service Portal' },
];

export const portalsForBrand = brand =>
  ALL_PORTALS.filter(portal => portal.key.startsWith(brand === 'PRST' ? 'PRST_' : 'CENTERLINE_'));

export const MANUAL_PORTALS = portalsForBrand(process.env.REACT_APP_BRAND);

// Which portal's manual a signed-in user downloads: client-type users get the client
// portal's manual; everyone else gets the environment's configured portal. PRST has no
// client portal, so PRST clients fall back to the configured PRST_SERVICE.
export const portalForUser = userType =>
  userType === 'Client' && process.env.REACT_APP_BRAND !== 'PRST'
    ? 'CENTERLINE_CLIENT'
    : process.env.REACT_APP_MANUAL_PORTAL;
